import { render, staticRenderFns } from "./FormularioContactanos.vue?vue&type=template&id=4cf2cfa6&scoped=true&"
import script from "./FormularioContactanos.vue?vue&type=script&lang=js&"
export * from "./FormularioContactanos.vue?vue&type=script&lang=js&"
import style0 from "./FormularioContactanos.vue?vue&type=style&index=0&id=4cf2cfa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2cfa6",
  null
  
)

export default component.exports